import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    mapTypes: {
        roadmap: true,
        satellite: false,
        hybrid: false,
        terrain: false
    }
};

const mapLayerSlice = createSlice({
    name: 'mapLayer',
    initialState,
    reducers: {
        toggleMapType: (state, action) => {
            const type = action.payload;
            state.mapTypes[type] = !state.mapTypes[type];
        }
    }
});

export const {toggleMapType} = mapLayerSlice.actions;

export default mapLayerSlice.reducer;
